export enum SapDocumentType {
  Containers = "Containers",
  Project = "Project"
}
